import { useSelector } from 'react-redux';

import { GlobalStateType } from 'Lib/reduxType';

import { getIsMobileLayout } from 'Store/appSettings/selectors';

import getAppDownloadLinks from './getAppDownloadLinks';

const useAppDownloadLinks = () => {
  const os = useSelector((state: GlobalStateType) => state.context.os);
  const isMobile = useSelector(getIsMobileLayout);

  return getAppDownloadLinks({ isMobile, os });
};

export default useAppDownloadLinks;
